"use client";

import { withFallback } from "../with-fallback";

export const AutomaticWithdrawElement = withFallback({
	displayName: "AutomaticWithdrawElement",
	type: "automatic-withdraw-element",
} as const);
